$(document).ready(function () {
  $('.location .items').each(function () {
    if ($(this).find('> li').length > 1) {
      $(this).slick({
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        swipe: true,
      });

      // On before slide change
      $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        updateLocationSize($(this).find('.location_item[data-id="' + (nextSlide + 1) + '"]'));
      });
    }
  })

  $('.location-filters li span').click(function (e) {
    if (!$(this).hasClass('active')) {
      $('.map-dots').find('.' + $(this).attr('data-state')).addClass('visible');
      $(this).addClass('active');
    } else {
      $('.map-dots').find('.' + $(this).attr('data-state')).removeClass('visible');
      $(this).removeClass('active');
    }
  });

  $('.map-dots .dot').click(function (e) {
    $('.map-dots .dot.active').removeClass('active');
    $(this).toggleClass('active');

    $('.layout-content__content .locations .location.active').removeClass('active');
    let location = $('.layout-content__content .locations .location[data-id="' + $(this).attr('data-id') + '"]');
    location.addClass('active');
    updateLocationSize(location.find('.location_item[data-id="1"]'));
  });

  $('.map-dots .dot[data-id="3"]').click();
});


function updateLocationSize(location) {
  if (location.attr('data-location-size') != undefined) {
    $('.location-size .value').html(location.attr('data-location-size'));
    $('.location-size .value').counterUp({
      delay: 10,
      time: 1000,
    });

    $('.location-size').addClass('active');
  } else {
    $('.location-size').removeClass('active');
  }

  if (location.parents('.location').hasClass('coming-soon')) {
    $('.location-size').addClass('coming-soon');
  } else {
    $('.location-size').removeClass('coming-soon');
  }
}
